import CryptoJS from 'crypto-js';

const KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'kzerodiary-default-key-change-me';
const PREFIX = 'enc:';

// Criptografa uma string — retorna prefixo "enc:" + cipher em base64
function encryptField(value) {
  if (!value || typeof value !== 'string') return value;
  if (value.startsWith(PREFIX)) return value; // já criptografado
  return PREFIX + CryptoJS.AES.encrypt(value, KEY).toString();
}

// Descriptografa uma string — remove prefixo e retorna texto original
function decryptField(value) {
  if (!value || typeof value !== 'string') return value;
  if (!value.startsWith(PREFIX)) return value; // não está criptografado
  try {
    const bytes = CryptoJS.AES.decrypt(value.slice(PREFIX.length), KEY);
    return bytes.toString(CryptoJS.enc.Utf8) || value;
  } catch {
    return value;
  }
}

// Aplica fn nos campos sensíveis de um array de objetos
function transformArray(arr, campos, fn) {
  if (!Array.isArray(arr)) return arr;
  return arr.map(item => {
    if (!item || typeof item !== 'object') return item;
    const novo = { ...item };
    for (const campo of campos) {
      if (novo[campo] !== undefined) novo[campo] = fn(novo[campo]);
    }
    return novo;
  });
}

// Criptografa todos os campos sensíveis antes de salvar
export function encryptData(data) {
  if (!data || typeof data !== 'object') return data;
  const d = { ...data };

  // clientes: email, emailFinanceiro
  if (d.clientes) {
    d.clientes = transformArray(d.clientes, ['email', 'emailFinanceiro'], encryptField);
  }

  // atas: emailsDestinatarios
  if (d.atas) {
    d.atas = transformArray(d.atas, ['emailsDestinatarios'], encryptField);
  }

  // tr_dados.perfis: telefone, whatsapp
  if (d.tr_dados?.perfis) {
    d.tr_dados = {
      ...d.tr_dados,
      perfis: transformArray(d.tr_dados.perfis, ['telefone', 'whatsapp'], encryptField),
    };
  }

  return d;
}

// Descriptografa todos os campos sensíveis após carregar
export function decryptData(data) {
  if (!data || typeof data !== 'object') return data;
  const d = { ...data };

  if (d.clientes) {
    d.clientes = transformArray(d.clientes, ['email', 'emailFinanceiro'], decryptField);
  }

  if (d.atas) {
    d.atas = transformArray(d.atas, ['emailsDestinatarios'], decryptField);
  }

  if (d.tr_dados?.perfis) {
    d.tr_dados = {
      ...d.tr_dados,
      perfis: transformArray(d.tr_dados.perfis, ['telefone', 'whatsapp'], decryptField),
    };
  }

  return d;
}
